import { render } from "./App.vue?vue&type=template&id=3b0ecf0f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b0ecf0f&lang=scss"

import exportComponent from "C:\\Users\\crescendoCat\\Work Space\\Nodejs\\thripsui\\vue-thripsui\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__